import React from 'react';

// Country code to flag image URL mapping using a public CDN
// Using flagcdn.com which provides free flag images
const getFlagImageUrl = (countryCode) => {
  if (!countryCode || countryCode.length !== 2) return null;
  const code = countryCode.toLowerCase();
  return `https://flagcdn.com/w40/${code}.png`;
};

// Convert emoji flag back to ISO code
const getISOFromEmoji = (emoji) => {
  if (!emoji || emoji.length !== 2) return '';
  const code1 = emoji.codePointAt(0);
  const code2 = emoji.codePointAt(1);
  // Regional indicator symbols range: 0x1F1E6 to 0x1F1FF (127462 to 127487)
  if (code1 >= 127462 && code1 <= 127487 && code2 >= 127462 && code2 <= 127487) {
    const char1 = String.fromCharCode(code1 - 127397);
    const char2 = String.fromCharCode(code2 - 127397);
    return char1 + char2;
  }
  return '';
};

/**
 * FlagDisplay Component - Cross-platform flag display using images
 * Works on all OS including Windows, macOS, Linux, iOS, Android
 * 
 * @param {string} flag - Emoji flag or ISO country code (e.g., "🇺🇸" or "US")
 * @param {string} isoCode - Optional ISO code (2-letter) as fallback
 * @param {number} size - Size of the flag in pixels (default: 32)
 * @param {string} alt - Alt text for the flag image
 */
const FlagDisplay = ({ flag, isoCode, size = 32, alt }) => {
  // Determine the ISO code to use
  let countryCode = '';
  
  if (isoCode && isoCode.length === 2) {
    countryCode = isoCode.toUpperCase();
  } else if (flag && flag.length === 2) {
    // If flag prop is already an ISO code
    countryCode = flag.toUpperCase();
  } else if (flag) {
    // Try to convert emoji to ISO code
    countryCode = getISOFromEmoji(flag);
  }
  
  const imageUrl = getFlagImageUrl(countryCode);
  
  if (!imageUrl) {
    return <span>-</span>;
  }
  
  const displayAlt = alt || (countryCode ? `${countryCode} Flag` : 'Country Flag');
  
  return (
    <img
      src={imageUrl}
      alt={displayAlt}
      style={{
        width: `${size}px`,
        height: 'auto',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
        display: 'inline-block',
        verticalAlign: 'middle',
      }}
      onError={(e) => {
        // Fallback if image fails to load
        e.target.style.display = 'none';
        e.target.nextSibling.style.display = 'inline';
      }}
    />
  );
};

export default FlagDisplay;
export { getFlagImageUrl, getISOFromEmoji };
